import * as React from 'react';
import { connect } from 'react-redux';
import { select } from '@rematch/select';
import { dispatch } from '../../store';
import { Trans } from 'react-i18next';

import { NotificationsForm } from '../../atoms/notification-settings-form';
import { UserZoneLayout } from '../../layouts/UserZoneLayout';
import { SettingsSideNav } from './SettingsSideNav';
import { showAlert } from '../../atoms/alert';

export class Renderer extends React.Component {
  onSubmit = async (result) => {
    return await dispatch.session.updateUser({
      id: this.props.user.id,
      data: result,
    });
  };

  onSuccess = () => {
    showAlert({
      type: 'success',
      message: <Trans>Notification settings was successfully updated.</Trans>,
    });
  };

  render() {
    const { push_notifications_settings, email_notifications_settings, badge_notifications_settings } = this.props.user;
    return (
      <UserZoneLayout navigation={<SettingsSideNav />}>
        <NotificationsForm
          push_notifications_settings={push_notifications_settings}
          email_notifications_settings={email_notifications_settings}
          badge_notifications_settings={badge_notifications_settings}
          onSubmit={this.onSubmit}
          onSuccess={this.onSuccess}
        />
      </UserZoneLayout>
    );
  }
}

const mapState = (state) => ({
  user: select.session.user(state),
});

export const PageNotificationSettings = connect(mapState)(Renderer);
